export const enterprise = [
  { teams: '2-3', price: 720 },
  { teams: '4-7', price: 1440 },
  { teams: '8-15', price: 2880 },
  { teams: '16-25', price: 5500 },
  { teams: '26+' }
]

export const partner = [
  { teams: '1-4', price: 800 },
  { teams: '5-10', price: 1800 },
  { teams: '11-20', price: 3800 },
  { teams: '21-50', price: 8000 },
  { teams: '51-100', price: 16000 },
  { teams: '101+' }
]
